import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import "./Dimensions.css";
import { LanguageContext } from "../../context/LanguageContext";

const API_BASE = process.env.REACT_APP_API_BASE_URL;

const Dimensions = () => {
  const { currentLang } = useContext(LanguageContext);
  const [activeTab, setActiveTab] = useState("overall");
  const [data, setData] = useState(null);

  const resolveUrl = (url) => {
    if (!url) return "";
    return url.startsWith("http") ? url : `${API_BASE}${url}`;
  };

  useEffect(() => {
    const fetchDimensions = async () => {
      try {
        const res = await axios.get(
          `${API_BASE}/api/DimensionsSection?lang=${currentLang}`
        );
        setData(res.data);
      } catch (error) {
        console.error("Error fetching Dimensions data:", error);
      }
    };

    fetchDimensions();
  }, [currentLang]);

  if (!data) return null;

  const renderLines = (text) =>
    text
      ?.split("\n")
      .filter((x) => x.trim() !== "")
      .map((line, index) => {
        const [label, value] = line.split(":");
        return (
          <li key={index}>
            <span className="circle">{index + 1}</span>
            {label?.trim()}{" "}
            <span className="value">{value?.trim()}</span>
          </li>
        );
      });

  const renderTab = (text, imageUrl, title) => (
    <div className="dimensions-content">
      <div className="dimensions-left">
        <ul>{renderLines(text)}</ul>
        <button>Discover all Specifications</button>
      </div>

      <div className="dimensions-right">
        <img
          src={resolveUrl(imageUrl)}
          alt={title}
          loading="lazy"
        />
      </div>
    </div>
  );

  return (
    <section className="dimensions">
      <h1 className="dimensions-title">{data.title}</h1>

      {/* Tabs */}
      <div className="dimensions-tabs">
        <div
          className={`tab ${activeTab === "overall" ? "active" : ""}`}
          onClick={() => setActiveTab("overall")}
        >
          {data.tab1Title}
        </div>

        <div
          className={`tab ${activeTab === "storage" ? "active" : ""}`}
          onClick={() => setActiveTab("storage")}
        >
          {data.tab2Title}
        </div>

        <div
          className={`tab ${activeTab === "offroad" ? "active" : ""}`}
          onClick={() => setActiveTab("offroad")}
        >
          {data.tab3Title}
        </div>
      </div>

      {/* Content */}
      {activeTab === "overall" &&
        renderTab(data.overallText, data.image1Url, data.tab1Title)}

      {activeTab === "storage" &&
        renderTab(data.storageText, data.image2Url, data.tab2Title)}

      {activeTab === "offroad" &&
        renderTab(data.offroadText, data.image3Url, data.tab3Title)}
    </section>
  );
};

export default Dimensions;
